import { styled } from '@linaria/react';

export const DocumentsPageWrapper = styled.div`
    height: calc(100vh - 60px);
    background: #f8f9fa;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: 768px) {
        height: auto;
        min-height: 0;
        overflow: visible;
    }
`;

export const DocumentsPageContainer = styled.div`
    background: transparent;
    max-width: 1200px;
    margin: 0 auto;
    padding: 1.5rem 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 0;

    @media (min-width: 1281px) {
        max-width: 1400px;
    }

    @media (min-width: 1600px) {
        max-width: 1600px;
    }

    @media (min-width: 1920px) {
        max-width: 1800px;
    }
`;

export const DocumentsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr 1fr;
    gap: 24px;
    margin-top: 20px;
    flex: 1;
    min-height: 0;

    @media (max-width: 1400px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        grid-template-rows: none;
        grid-auto-rows: auto;
        gap: 16px;
        margin: 20px 1rem;
        padding-bottom: 2rem;
    }
`;

export const DocumentCategoryCard = styled.div`
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.2s ease;
    min-height: 220px;

    @media (max-width: 768px) {
        overflow: visible;
    }

    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
`;

export const RGMCategoryCard = styled(DocumentCategoryCard)`
    grid-column: -2 / -1;
    grid-row: 1 / span 2;

    @media (max-width: 768px) {
        grid-column: auto;
        grid-row: auto;
    }
`;

export const CategoryHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    flex-shrink: 0;
`;

export const CategoryImage = styled.div`
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;
    border: 1px solid #d3d3d3;
    opacity: 0.85;
`;

export const CategoryTitle = styled.h3`
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #333;
`;

export const CategoryContent = styled.div`
    padding: 12px 16px;
    flex: 1;
    overflow-y: auto;
    min-height: 0;

    @media (max-width: 768px) {
        overflow-y: visible;
    }

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #aaa;
    }
`;
